import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import MobileStepper from "@mui/material/MobileStepper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

// mui icons
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
// 3rd party
import SwipeableViews from "react-swipeable-views";

// react icons
import { AiFillStar } from "react-icons/ai";
import { FaRegHeart } from "react-icons/fa";
import {
  flexBetween,
  dFlex,
  carouselDot,
  fixedIcon,
  carouselImage,
  fixedBottom,
} from "./../themes/commonStyles";
import "./CarouselCard.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link,useNavigate } from "react-router-dom";


var cart = "a";

const CarouselCard = ({ location, carousel }) => {
  console.log(window.pageYOffset)
  const [skeletonScreen, setSkeletonScreen] = useState(false);
  useEffect(() => {
    if (cart == "a") {
      setSkeletonScreen(true);
      setTimeout(() => {
        cart = "b";
        setSkeletonScreen(false);
      }, 5000);
    }
  }, []);

  const [activeStep, setActiveStep] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.outerWidth);
  var navigate = useNavigate();
  window.addEventListener("resize", function () {
    setWindowWidth(window.outerWidth);
  });

  const maxSteps = location.locationImages.length; // so that we know how many dots

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1); // jumps when we click the next arrow
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1); // when we click the back arrow
  };

  const handleStepChange = (step) => {
    setActiveStep(step); // handle swipe change
  };
  return (
    <div onClick={()=>navigate('/yacht/details')}>
    <Box
      className="carouselCard"
      sx={{
        flexGrow: 1,
        position: "relative",
      }}
    >
      {/* <Link
        style={{ textDecoration: "none", color: "black" }}
        to="/yacht/details"
      > */}
      {skeletonScreen ? null : (
        <Box sx={fixedIcon}>
          <FaRegHeart size={24} color="#fff" className="cartHeart" 
          onClick={(e)=>{
            navigate('/register')
            e.stopPropagation();
          }}
          />
        </Box>
      )}

      {
        location.locationImages.length &&
          (skeletonScreen ? (
            <Skeleton
              style={{ borderRadius: "10px" }}
              height={
                windowWidth > 650
                  ? carousel
                    ? windowWidth > 999
                      ? "18vw"
                      : "26vw"
                    : "22vw"
                  : windowWidth > 430
                  ? "40vw"
                  : windowWidth > 430
                  ? "75vw"
                  : "65vw"
              }
              component="img"
            />
          ) : (
            <SwipeableViews
              axis={"x"}
              index={activeStep}
              onChangeIndex={handleStepChange}
              enableMouseEvents
              className="MultiSwipeableViews"
            >
              {location.locationImages.map((step, index) => {
                return (
                  <div
                    key={step.id}
                    className="www"
                    // style={{borderRadius:'50%'}}
                  >
                    <Box
                      component="img"
                      maxHeight={
                        windowWidth > 650
                          ? carousel
                            ? windowWidth > 999
                              ? "18vw"
                              : "26vw"
                            : "22vw"
                          : windowWidth > 430
                          ? "40vw"
                          : windowWidth > 430
                          ? "75vw"
                          : "65vw"
                      }
                      minHeight={
                        windowWidth > 650
                          ? carousel
                            ? windowWidth > 999
                              ? "18vw"
                              : "26vw"
                            : "18vw"
                          : windowWidth > 430
                          ? "25vw"
                          : windowWidth > 430
                          ? "75vw"
                          : "65vw"
                      }
                      className={
                        carousel && windowWidth < 500
                          ? "ss carouselSmall"
                          : "ss"
                      }
                      // borderRadius={'50%'}
                      sx={carouselImage}
                      src={step.url}
                      alt={step.id}
                    ></Box>
                  </div>
                );
              })}
            </SwipeableViews>
          )) //x
      }

      {skeletonScreen ? null : (
        <Box sx={fixedBottom}>
          <div className="cardManagement">
            <Button
              style={{
                color: "white",
                background: "transparent",
                marginTop: "-70%",
              }}
              size="small"
              className={windowWidth > 900 ? "cardBackIcon" : "carouseBackIcon"}
              sx={carouselDot}
              onClick={(e)=>{
                handleBack()
                e.stopPropagation();
              }
              }
              
              disabled={activeStep === 0}
            >
              {(activeStep !== 0) &&
              <KeyboardArrowLeft
                style={{
                  color: "black",
                  borderRadius: 50,
                  background: "white",
                }}
              />
}
            </Button>

            <div className="dotMain">
              {location.locationImages.map((v, i) => {
                return (
                  <div
                    className={
                      i == activeStep ? "selected dot" : "notSelected dot"
                    }
                  ></div>
                );
              })}
            </div>

            <Button
              size="small"
              style={{
                color: "white",
                background: "transparent",
                marginTop: "-70%",
              }}
              sx={carouselDot}
              className={windowWidth > 900 ? "cardforIcon" : "carouseLForIcon"}
              onClick={(e)=>{
                handleNext()
                e.stopPropagation();
              }}
              disabled={activeStep === maxSteps - 1}
            >
              {(activeStep !== maxSteps - 1) &&
              <KeyboardArrowRight
                style={{
                  color: "black",
                  borderRadius: 50,
                  background: "white",
                }}
              />
}
            </Button>
          </div>
        </Box>
      )}
      <Link
        style={{ textDecoration: "none", color: "black" }}
        to="/yacht/details"
      >
        <Box sx={flexBetween}>
          <Box sx={{ mt: 2 }} style={{ textAlign: "left" }} className="cardTxt">
            {skeletonScreen ? (
              <Skeleton count={1} />
            ) : (
              <Typography component="h3">{location.location}</Typography>
            )}
            <Typography component="h4">
              {skeletonScreen ? <Skeleton count={1} /> : location.days}
            </Typography>
            <Typography component="h5">
              {skeletonScreen ? <Skeleton count={1} /> : location.price}
            </Typography>
          </Box>
          <Box sx={{ mt: 2 }}>
            <Box sx={dFlex}>
              {location.isNew ? (
                <React.Fragment>
                  {skeletonScreen ? (
                    <Skeleton count={1} />
                  ) : (
                    <>
                      <Typography component="h5">"New"</Typography>
                      <AiFillStar size={18} />
                    </>
                  )}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {skeletonScreen ? (
                    <Skeleton count={1} />
                  ) : (
                    <>
                      <Typography component="h5"> {location.rating}</Typography>
                      <AiFillStar size={18} />
                    </>
                  )}
                </React.Fragment>
              )}
            </Box>
          </Box>
        </Box>
      </Link>
    </Box>
    </div>
  );
};

export default CarouselCard;
